import TableSalary from "./TableSalary";

export default TableSalary;
